export default "__VITE_ASSET__Bnu8gDUX__"